/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, callbacks = [];
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId])
/******/ 				callbacks.push.apply(callbacks, installedChunks[chunkId]);
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules);
/******/ 		while(callbacks.length)
/******/ 			callbacks.shift().call(null, __webpack_require__);
/******/
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// object to store loaded and loading chunks
/******/ 	// "0" means "already loaded"
/******/ 	// Array means "loading", array contains callbacks
/******/ 	var installedChunks = {
/******/ 		0:0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId, callback) {
/******/ 		// "0" is the signal for "already loaded"
/******/ 		if(installedChunks[chunkId] === 0)
/******/ 			return callback.call(null, __webpack_require__);
/******/
/******/ 		// an array means "currently loading".
/******/ 		if(installedChunks[chunkId] !== undefined) {
/******/ 			installedChunks[chunkId].push(callback);
/******/ 		} else {
/******/ 			// start chunk loading
/******/ 			installedChunks[chunkId] = [callback];
/******/ 			var head = document.getElementsByTagName('head')[0];
/******/ 			var script = document.createElement('script');
/******/ 			script.type = 'text/javascript';
/******/ 			script.charset = 'utf-8';
/******/ 			script.async = true;
/******/
/******/ 			script.src = __webpack_require__.p + "thunder." + ({"1":"vippay","2":"prizelist"}[chunkId]||chunkId) + ".min.js";
/******/ 			head.appendChild(script);
/******/ 		}
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "http://img.vip.kanimg.com/lib/thunderjs/1.5.6/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(1);
	var main = __webpack_require__(2);
	var msgbox = __webpack_require__(7);
	var user = __webpack_require__(6);
	var login = __webpack_require__(4);
	var template = __webpack_require__(12);
	var tj = __webpack_require__(13);
	var util = __webpack_require__(3);
	var logistics = __webpack_require__(14);
	
	
	__webpack_require__(16);
	__webpack_require__(17);
	
	$(document).on('click', '.act_vip', function() {
	    var pids = $(this).attr('pids');
	    if (pids) {
	        pids = new Function('return ' + pids)()
	    }
	    pay($(this).attr('pid'), pids);
	}).on('click', '.act_logistics', function() {
	    logistics();
	}).on('click', '.act_prize, act_prize_list', function() {
	    prizelist();
	}).on('click', '.act_address', function() {
	    address();
	}).on('click', '.act_info', function(){
	    var gid =  $(this).attr('gid')
	
	    info(gid)
	})
	
	var pay = function(pid, pids) {
	    __webpack_require__.e/* nsure */(1, function(require) {
	        var pay = __webpack_require__(18);
	        pay(pid, pids);
	    });
	}
	
	pay.after = function(fn) {
	    __webpack_require__.e/* nsure */(1, function(require) {
	        var pay = __webpack_require__(18);
	        pay.after(fn);
	    });
	}
	
	var prizelist = function() {
	    __webpack_require__.e/* nsure */(2, function(require) {
	        var prizelist = __webpack_require__(21);
	        prizelist();
	    });
	}
	
	var address = function() {
	    __webpack_require__.e/* nsure */(2, function(require) {
	        var prizelist = __webpack_require__(21);
	        prizelist.address();
	    });
	}
	
	var info = function(gid){
	    __webpack_require__.e/* nsure */(2, function(require) {
	        var prizelist = __webpack_require__(21);
	        prizelist.info(gid);
	    });
	}
	
	window.thunder = function(fn) {
	    $(function() {
	        fn.call({
	            util: util,
	            main: main,
	            msgbox: msgbox,
	            user: user,
	            login: login,
	            template: template,
	            pay: pay,
	            tj: tj,
	            prizelist: prizelist,
	            address: address,
	            info: info
	        });
	        main.start();
	        window.thunder === null;
	    });
	}


/***/ }),
/* 1 */
/***/ (function(module, exports) {

	module.exports = jQuery;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	if (!window.active_cfg) {
	    throw '配置文件不存在';
	}
	
	window.domainList = {
	    dyactive2: 'http://dyactive2.vip.xunlei.com',
	    dyactive: 'http://dyactive.vip.xunlei.com',
	    dyact: 'http://dyact.vip.xunlei.com',
	    dynamic: 'http://dynamic.vip.xunlei.com',
	    dypay: 'http://dypay.vip.xunlei.com',
	    act: 'http://act.vip.xunlei.com',
	    vip: 'http://vip.xunlei.com'
	};
	
	var login_config = {
	    cookie_list: 'vip_nickname vip_usrname vip_growvalue vip_expiredate vip_level vip_isyear vip_paytype vip_isvip vip_daily vip_payname vip_is_good_number vip_num_is_open_vip vip_num_due_time vip_safebox vip_autopay act_cmb vas_type jsq_isvip jsq_expiredate ischild history vip_expiredays vip_kn_isvip vip_kn_level vip_kn_expiredate jsq_growvalue jsq_expiredate jsq_level jsq_paytype jsq_type jsq_score jsq_expiretype jsq_trialvip jsq_trialexpire'.split(' '),
	    cookie_list_val: 'nickname usrname growvalue expiredate level isyear paytype isvip daily payname is_good_number num_is_open_vip num_due_time safebox autopay act_cmb vas_type jsq_isvip jsq_expiredate ischild history expiredays kn_isvip kn_level kn_expiredate jsq_growvalue jsq_expiredate jsq_level jsq_paytype jsq_type jsq_score jsq_expiretype jsq_trialvip jsq_trialexpire'.split(' ')
	};
	
	var $ = __webpack_require__(1);
	$.live = function(selects, fn) {
	    return $(document).on('click', selects, fn);
	}
	
	$.jsonp = function(url, data, callback) {
	    if (typeof data === 'function') {
	        callback = data;
	        data = '';
	    }
	
	    var _callback = function(rs) {
	        if (rs.result === -100) {
	            clearCookie();
	            logout();
	            login();
	        } else {
	            callback(rs);
	        }
	    }
	
	    return $.ajax({
	        url: url,
	        data: data,
	        dataType: 'jsonp',
	        success: _callback
	    });
	}
	
	window.ajax = function(action, data, success, error) {
	    if (!haslogin()) {
	        login();
	        return;
	    }
	    var url = 'http://dyactive2.vip.xunlei.com';
	    if (typeof action !== 'string') {
	        throw 'error action';
	    }
	    if (typeof data === 'function') {
	        error = success;
	        success = data;
	        data = {};
	    } else {
	        data = data || {};
	    }
	
	    data.action = action;
	    data.actid = active_cfg.base.actid;
	
	    return $.ajax({
	        url: 'http://dyactive2.vip.xunlei.com/iface/',
	        dataType: 'jsonp',
	        data: data,
	        success: function(r) {
	            if (r.result === -100) {
	                clearCookie();
	                logout();
	                login();
	            } else {
	                success && success.call(this, r);
	            }
	        },
	        error: error
	    });
	}
	
	$.left = function(leftTime) {
	
	    function checkTime(i) {
	        if (i < 10) {
	            i = "0" + i;
	        } else {
	            i = "" + i;
	        }
	        return i;
	    }
	    var days = parseInt(leftTime / 60 / 60 / 24, 10);
	    var hours = parseInt(leftTime / 60 / 60 % 24, 10);
	    var minutes = parseInt(leftTime / 60 % 60, 10);
	    var seconds = parseInt(leftTime % 60, 10);
	    days = checkTime(days);
	    hours = checkTime(hours);
	    minutes = checkTime(minutes);
	    seconds = checkTime(seconds);
	    return {
	        d: days,
	        h: hours,
	        m: minutes,
	        s: seconds
	    }
	}
	
	var util = __webpack_require__(3);
	var login = __webpack_require__(4);
	var user = __webpack_require__(6);
	var msgbox = __webpack_require__(7);
	var renew = __webpack_require__(9);
	var head = __webpack_require__(11);
	var actid = active_cfg.base.actid;
	document.title = active_cfg.base.actname;
	document.domain = 'xunlei.com';
	var referfrom = util.getSearch('referfrom');
	
	if (referfrom) {
	    setRealCookie('referfrom', referfrom, undefined, 1);
	}
	
	function start() {
	    if(location.host === 'vip.xunlei.com'){
	        addNavAni();
	    }
	    bindEvents();
	    init();
	    if (login.haslogin()) {
	        loginInit();
	    } else {
	        loginInit.fail && loginInit.fail();
	    }
	}
	
	function addNavAni() {
	    //导航动画
	    function navGif(height, times, speed) {
	        var _position = 0,
	            _height = height * times * (-1),
	            _interval;
	
	        _interval = setInterval(function() {
	            if (_position >= _height) {
	                $(".vip-header .gif").css("background-position", "center " + _position + "px");
	                _position -= speed;
	            } else {
	                $(".vip-header .gif").css("background", "none");
	                clearInterval(_interval);
	            }
	        }, 100);
	    }
	
	    $(document).ready(function() {
	        navGif(186, 3, 10);
	    })
	}
	
	function setPageNav(index) {
	    //页面导航
	    if (index) {
	        $('ul.menu li[index="' + index + '"]').addClass('cur');
	    }
	}
	
	function bindEvents() {
	    $('#hd_index').on('mouseenter', '.vip-usertop', function() {
	        $('#header-login .p_selfcon').show();
	    }).on('mouseleave', '.vip-usertop', function() {
	        $('#header-login .p_selfcon').hide();
	    }).on('click', '[name="logout"]', function() {
	        login.logout();
	        return false;
	    }).on('click', '[name="login"]', function() {
	        login.login();
	        return false;
	    });
	
	    //导航hover出二级菜单
	    $(".vip-header .menu li").hover(function() {
	        var subnav_ind = $(this).index();
	        $(".subnav_wp").show();
	        $(".subnav_wp .menu").hide();
	        $(".subnav_wp").find(".subnav_" + subnav_ind).show();
	    }, function() {
	        $(".subnav_wp").hide();
	    });
	    $(".subnav_wp").hover(function() {
	        $(this).show();
	    }, function() {
	        $(this).hide();
	        $(".subnav_wp .menu").hide();;
	    });
	}
	
	function init() {
	
	    $.ajax({
	        url: 'http://dyactive2.vip.xunlei.com/iface/?action=init&actid=' + actid,
	        dataType: 'jsonp',
	        success: function(r) {
	            if (r.result == 0) {
	                var data = r.data;
	                r.data.message && msgbox.showErrorMsg(r.data.message);
	                init.cb && init.cb(data);
	            }
	        }
	    })
	}
	
	function onInit(fn) {
	    init.cb = fn;
	}
	
	function loginInit() {
	    $.ajax({
	        url: 'http://dyactive2.vip.xunlei.com/iface/?action=logininit&actid=' + actid,
	        dataType: 'jsonp',
	        data: {
	            userInfo: 1
	        },
	        success: function(r) {
	            if (r.result == 0) {
	                var data = r.data;
	                setUserInfo(data.userInfo);
	                renew();
	                r.data.message && msgbox.showErrorMsg(r.data.message);
	                loginInit.cb && loginInit.cb(data);
	            } else if (r.result === -100) {
	                clearCookie();
	                loginInit.fail && loginInit.fail();
	            }
	        }
	    })
	}
	
	function onLoginInit(fn, fn2) {
	    loginInit.cb = fn;
	    loginInit.fail = fn2;
	}
	
	var userInfo = {};
	
	function setUserInfo(data) {
	    if (data) {
	        userInfo = data;
	
	        var regcookie = function(cname, name) {
	            if (data[name] != undefined) setCookie(cname, data[name]);
	        };
	        var cookie_list = login_config.cookie_list;
	        var cookie_list_val = login_config.cookie_list_val;
	        for (var i = 0, len = cookie_list.length; i < len; i++) {
	            regcookie(cookie_list[i], cookie_list_val[i]);
	        }
	        head.init()
	        //initHeader();
	    }
	}
	
	window.loginInit = loginInit;
	module.exports = {
	    start: start,
	    init: init,
	    setPageNav: setPageNav,
	    loginInit: loginInit,
	    onInit: onInit,
	    onLoginInit: onLoginInit
	}


/***/ }),
/* 3 */
/***/ (function(module, exports) {

	var Util = {
		getSearch: function(key) {
			return new RegExp('[&?]' + key + '=([^&]*)', 'i').test(location.search) ? decodeURIComponent(RegExp.$1) : '';
		},
		isNull: function(a) {
			return typeof a == "object" && !a;
		},
		getUrlParam: function(url, parameter) {
			url = url || location.href;
			var result = url.match(new RegExp("[\#|\?]([^#]*)[\#|\?]?"));
			url = "&" + (this.isNull(result) ? "" : result[1]);
			result = url.match(new RegExp("&" + parameter + "=", "i"));
			return this.isNull(result) ? undefined : url.substr(result.index + 1).split("&")[0].split("=")[1];
		},
		initEvents: function(Events) {
			var key, keyArr, delElems, elems, events;
			var spiltElems = function(elems) {
				return elems.split('&').join(',');
			}
			for (key in Events) {
				keyArr = key.split('|');
				switch (keyArr.length) {
					case 3:
						delElems = spiltElems(keyArr[0]);
						elems = spiltElems(keyArr[1]);
						events = spiltElems(keyArr[2]);
						delElems = document;
						$(delElems).on(events, elems, Events[key]);
						break;
					case 2:
						elems = spiltElems(keyArr[0]);
						events = spiltElems(keyArr[1]);
						$(elems).on(events, Events[key]);
						break;
					default:
						break;
				}
			}
		}
	};
	module.exports = Util;


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(1);
	__webpack_require__(5);
	var isThunder = / Thunder/.test(navigator.userAgent);
	
	$(function() {
		if (isThunder) {
			xl9.api.onUserLogout(function() {
				location.reload();
			});
			xlQuickLogin.setLoginExt(function(){
	
		    });
		} else {
			xlQuickLogin.init({
				loginID: '101',
				registerID: 'act',
				UI_THEME: 'popup',
				// 登录成功后回调函数，当 SET_ROOT_DOMAIN == true 时该项可用
				LOGIN_SUCCESS_FUNC: function() {
					window.loginInit();
				},
				// 注册成功后回调函数，当 SET_ROOT_DOMAIN == true 时该项可用
				REGISTER_SUCCESS_FUNC: function() {
					location.reload();
				},
				// 关闭按钮回调函数，只适用弹窗主题
				POPUP_CLOSE_FUNC: function() {},
				//登出后的回调
				LOGOUT_FUNC: function() {
					location.reload();
				}
			});
		}
	});
	
	function login() {
		if (isThunder) {
			xl9.api.showLoginDlg(function(err) {});
		} else {
			xlQuickLogin.popup();
		}
	}
	
	function haslogin() {
		return getRealCookie('sessionid') && getRealCookie('userid')
	}
	
	function logout() {
		clearCookie();
		if (isThunder) {
			xl9.api.logout(function(err) {
	
			});
		} else {
			xlQuickLogin.logout();
		}
	}
	
	$.live('.login', function() {
		login();
	});
	
	$.live('.logout', function() {
		logout();
	});
	
	window.haslogin = haslogin;
	window.login = login;
	window.logout = logout;
	module.exports = {
		login: login,
		logout: logout,
		haslogin: haslogin
	};


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

	var trim = function(x) {
	    return x.toString().replace(/^\s|\s$/g, '');
	}
	var $ = __webpack_require__(1);
	
	function setCookie(name, value, hours, isBaseDomain) {
	    value = value + '';
	    if (isBaseDomain != undefined && isBaseDomain == 1) {
	        setRealCookie(name, value, hours, 1); //绑定到.xunlei中
	    } else {
	        var vipcookie = getRealCookie('vipcookie');
	        if (trim(value) == '') { //删除cookie
	            if (vipcookie != '') {
	                var check = getCookie(name);
	                if (check != '') {
	                    var cookies = vipcookie.split('&');
	                    var newcookie = new Array;
	                    for (var i = 0; i < cookies.length; i++) {
	                        var ary = cookies[i].split('=');
	                        if (ary.length > 1 && ary[0] != name) {
	                            newcookie.push(cookies[i]);
	                        }
	                    }
	                    vipcookie = newcookie.join('&');
	                }
	            }
	        } else { //添加cookie
	            //删除原生cookie中的此值
	            setRealCookie(name, '', 0);
	            if (vipcookie == '') {
	                vipcookie = trim(name) + '=' + encodeURIComponent(value);
	            } else {
	                //check if has the same item , if so , replace it , otherwise add it.
	                var check = getCookie(name);
	                if (check != '') {
	                    var cookies = vipcookie.split('&');
	                    for (var i = 0; i < cookies.length; i++) {
	                        var ary = cookies[i].split('=');
	                        if (ary.length > 1 && ary[0] == name) {
	                            cookies[i] = name + '=' + encodeURIComponent(value);
	                            break;
	                        }
	                    }
	                    vipcookie = cookies.join('&');
	                } else {
	                    vipcookie = vipcookie + '&' + trim(name) + '=' + encodeURIComponent(value);
	                }
	            }
	        }
	        if (hours != undefined) {
	            setRealCookie('vipcookie', vipcookie, hours);
	        } else {
	            setRealCookie('vipcookie', vipcookie);
	        }
	    }
	}
	
	function setRealCookie(name, value, hours, isBaseDomain) {
	    var domain
	    if (window.location.href.indexOf('jsq.xunlei.com') != -1) {
	        domain = "jsq.xunlei.com";
	    } else {
	        domain = location.host;
	    }
	    if (arguments.length > 2) {
	        var expireDate = new Date(new Date().getTime() + hours * 3600000);
	        if (isBaseDomain != undefined && isBaseDomain == 1) {
	            document.cookie = name + "=" + encodeURIComponent(value) + "; path=/; domain=xunlei.com; expires=" + expireDate.toGMTString();
	        } else {
	            document.cookie = name + "=" + encodeURIComponent(value) + "; path=/; domain=" + domain + "; expires=" + expireDate.toGMTString();
	        }
	    } else {
	        document.cookie = name + "=" + encodeURIComponent(value) + "; path=/; domain=" + domain;
	    }
	}
	
	function getCookie(name) {
	    var val = getRealCookie(name);
	    if (trim(val) == '') {
	        var vipcookie = getRealCookie('vipcookie');
	        if (trim(vipcookie) == '') {
	            return '';
	        }
	        var cookies = vipcookie.split('&');
	        for (var i = 0; i < cookies.length; i++) {
	            var ary = cookies[i].split('=');
	            if (ary.length > 1 && ary[0] == name) {
	                return decodeURIComponent(ary[1]);
	            }
	        }
	        return '';
	    } else {
	        return trim(val); //如果cookie中有该值，优先使用该值
	    }
	}
	
	function getRealCookie(name) {
	    return (document.cookie.match(new RegExp("(^" + name + "| " + name + ")=([^;]*)")) == null) ? "" : decodeURIComponent(RegExp.$2);
	}
	
	function clearCookie() {
	    //清除子域名
	    var ckeys = ["vipcookie", "vip_nickname", "ci_session", "vip_ci_session", "_x_a_"];
	    for (var i = 0, len = ckeys.length; i < len; i++) {
	        setRealCookie(ckeys[i], "", 0);
	    }
	    //主域名
	    var ckeys1 = ["sessionid", "usrname", "unickname", "nickname", "usernick", "userid", "usertype", "usernewno", "blogresult", "score", "order", "isvip", "sex", "upgrade", "logintype", "checkans", "checkpwd", "jumpkey"];
	    for (var i = 0, len = ckeys1.length; i < len; i++) {
	        setRealCookie(ckeys1[i], "", 0, 1);
	    }
	}
	
	window.setCookie = setCookie;
	window.setRealCookie = setRealCookie;
	window.getCookie = getCookie;
	window.getRealCookie = getRealCookie;
	window.clearCookie = clearCookie;


/***/ }),
/* 6 */
/***/ (function(module, exports) {

	/**
	 * @封装用户会员各种信息文件
	 * 需要在用户登录后才能调用这个文件，在访问接口asynProxy后调用有效
	 * @author caizhenbo
	 * create at 2015/4/11
	 */
	
	    var User = {};
	
	    /**
	     * 迅雷会员
	     */
	    User.isVip = function() {
	        var paytype = parseInt(getCookie("vip_paytype"));
	        var isvip = parseInt(getCookie("vip_isvip"));
	        if ((isvip == 1 || isvip == 2) && paytype < 1000) {
	            return 1;
	        } else {
	            return 0;
	        }
	    }
	    /**
	     * 迅雷会员
	     */
	    User.isStopVip = function() {
	        //return true;
	        var isvip = parseInt(getCookie("vip_isvip"));
	        if (isvip == 2) {
	            return true;
	        } else {
	            return false;
	        }
	
	    }
	
	    /***
	     * 迅雷迷你会员
	     */
	    User.isMiniVip = function() {
	        var paytype = parseInt(getCookie("vip_paytype"));
	        var isvip = parseInt(getCookie("vip_isvip"));
	        var vas_type = parseInt(getCookie("vas_type"));
	        if (this.isVip() && paytype < 1000 && vas_type == 1) {
	            return 1;
	        } else {
	            return 0;
	        }
	    }
	
	    /**
	     * 普通会员非白金
	     */
	    User.isNormalVip = function() {
	        var isvip = parseInt(getCookie("vip_isvip"));
	        var vas_type = parseInt(getCookie("vas_type"));
	        if (this.isVip() && vas_type == 2) {
	            return 1;
	        } else {
	            return 0;
	        }
	    }
	    /**
	     * 白金会员
	     */
	    User.isPlatinumVip = function() {
	        var paytype = parseInt(getCookie("vip_paytype"));
	        var isvip = parseInt(getCookie("vip_isvip"));
	        var vas_type = parseInt(getCookie("vas_type"));
	        var level = parseInt(getCookie("vip_level"))
	        if ((this.isVip() && vas_type == 3 ) || (this.isVip() && vas_type == 4 && level > 5 )) {
	            return 1;
	        } else {
	            return 0;
	        }
	    }
	    /**
	     * 手机用户
	     */
	    User.isMobileVip = function() {
	        var mobilevip = [3, 8, 9, 15, 103];
	        var paytype = parseInt(getCookie("vip_paytype"));
	        var isvip = parseInt(getCookie("vip_isvip"));
	        var vas_type = parseInt(getCookie("vas_type"));
	        if (this.isVip() && vas_type <= 3 && _in_array(paytype, mobilevip)) {
	            return 1;
	        } else {
	            return 0;
	        }
	    }
	
	    /**
	     * 判断是否体验会员
	     */
	    User.isTiyan = function() {
	        var isvip = getCookie('vip_isvip');
	        var vip_paytype = getCookie('vip_paytype');
	        if (this.isVip() == 1 && vip_paytype > 1000) {
	            return true;
	        } else {
	            return false;
	        }
	    }
	
	    /**
	     * 判断是否钻石会员，先改为超级
	     */
	    User.isDiamondVip = function() {
	        var isvip = getCookie('vip_isvip');
	        var vas_type = getCookie('vas_type');
	        if (this.isVip() == 1 && vas_type == 5) {
	            return true;
	        } else {
	            return false;
	        }
	    }
	
	    /**
	     * 判断是否钻石会员
	     */
	    User.isSuperVip = function() {
	        var isvip = getCookie('vip_isvip');
	        var vas_type = getCookie('vas_type');
	        if (this.isVip() == 1 && (vas_type == 5 || vas_type == 4)) {
	            return true;
	        } else {
	            return false;
	        }
	    }
	
	
	    /**
	     * 判断是否快鸟会员
	     */
	    User.isKuainiaoVip = function() {
	        var isvip = getCookie('vip_kn_isvip');
	        return isvip == 1 ? true :false;
	    }
	
	    /**
	     * 判断是否为过期会员
	     */
	    User.isOldvip = function() {
	        var vip_level = getCookie("vip_level"); //会员级别;已登陆的非会员默认为0;
	        var vip_isvip = getCookie("vip_isvip"); // 是否是 vip
	        var vip_expiredate = getCookie("vip_expiredate") ;
	        if (vip_level != null && vip_level != "" && vip_level != "0" && vip_isvip == 0) {
	            return true;
	        } else {
	            return false;
	        }
	    }
	
	    /**
	     * *
	     * 判断是否是新用户
	     */
	     User.isNewUser = function(){
	        var isVip = getCookie('vip_isvip'),
	            level = getCookie('vip_level');
	        if(isVip == 0 && level == '' || level == 0){
	            return 1;
	        }
	        return 0 ;
	    }
	
	    /**
	     * 判断是否为靓号
	     */
	    User.isGoodnum = function() {
	        var vip_isgoodnum = getCookie("vip_is_good_number")
	        if (vip_isgoodnum != null && vip_isgoodnum != "" && vip_isgoodnum == "1") {
	            return true;
	        } else {
	            return false;
	        }
	    }
	
	    /**
	     * 是否会员子帐号
	     */
	    User.isChild = function() {
	        var ischild = parseInt(getCookie("ischild"));
	        if (ischild == "1" || getCookie("vip_ischild") == 1) {
	            return 1;
	        } else {
	            return 0;
	        }
	    }
	    /**
	     * 是否为年费会员
	     */
	    User.isYearVip = function() {
	        var isyear = parseInt(getCookie("vip_isyear"));
	        if (isyear == "1") {
	            return 1;
	        } else {
	            return 0;
	        }
	    }
	
	    /**
	     * 是否为2009年10月前购买白金会员的历史用户
	     */
	    User.isHistoryVip = function() {
	        var ishistory = parseInt(getCookie("history"));
	        if (ishistory == "1") {
	            return 1;
	        } else {
	            return 0;
	        }
	    }
	
	    /**
	     * 获取用户的昵称
	     */
	    User.nickname = function() {
	        var nickname = getCookie("vip_nickname") ? getCookie("vip_nickname") : getCookie("usernick");
	        return nickname;
	    }
	
	    /*
	     *迅雷用户名
	     */
	    User.xlUsername = function() {
	        var usrname = getCookie("usrname");
	        var Usernewno = getCookie("Usernewno");
	        if (usrname != '' && usrname != '0') {
	            return usrname;
	        }
	        return Usernewno;
	
	    }
	    /**
	     * 获取用户的头像
	     */
	    User.avatar = function() {
	
	        return 'http://img.user.kanimg.com/usrimg/' + getCookie('userid') + '/100x100';
	    }
	
	    /**
	     *用户的成长值
	     */
	    User.daily = function() {
	        var daily = getCookie('vip_daily');
	        return daily;
	    }
	
	    /**
	     *用户等级
	     *
	     */
	    User.level = function() {
	        var level = getCookie('vip_level');
	        if (level == 'level' || level == '') {
	            level = 0;
	        }
	        return level;
	    }
	
	    /**
	     * 用户图标url
	     */
	    User.iconUrl = function(){
	        var iconUrl = '';
	        if(User.isSuperVip()){
	            iconUrl = 'http://vip.xunlei.com/vip_service/supervip/';
	        }else{
	            iconUrl = 'http://vip.xunlei.com/vip_service/mycenter/myvip.html';
	        }
	        return iconUrl;
	    }
	
	    /*
	     **返回会员身份判断
	     * return 0:非会员:1：迷你会员；2:普通会员；3：白金会员；4:钻石会员；
	     */
	    User.identity = function() {
	        if (this.isMiniVip()) {
	            return 1;
	        }
	        if (this.isNormalVip()) {
	            return 2;
	        }
	        if (this.isPlatinumVip()) {
	            return 3;
	        }
	        if (this.isDiamondVip()) {
	            return 4;
	        }
	        if(this.isSuperVip()){
	            return 5;
	        }
	        return 0;
	    }
	
	    /*
	     **会员有效期
	     */
	    User.expiredate = function() {
	        var expiredate = getCookie('vip_expiredate');
	        if (expiredate) {
	            return expiredate;
	        } else {
	            return '无';
	        }
	    }
	
	    /*
	     **用户会员图标
	     **return 用户快鸟会员身份图标class
	     */
	     User.knIcon = function(){
	        var iconClass = '';
	        if (getCookie('vip_kn_isvip') == 1) {
	            iconClass = 'icvip ickn';
	        }else{
	            iconClass = 'icvip icknhui';
	        }
	
	        return iconClass;
	    }
	
	    /*
	     *用户会员图标
	     * return 用户会员身份图标class
	     */
	    User.vipIcon = function(){
	        var id = parseInt(getCookie('vas_type'));
	        var level = this.level();
	        var iconClass = '';
	        switch(id){
	            case 1:
	               iconClass ='icvip icvip0'+ level + 'hui';
	                break;
	            case 2:
	                iconClass ='icvip icvip0'+ level;
	                break;
	            case 3:
	                iconClass ='icvip icgoldvip icgold0'+ level;
	                break;
	            case 4:
	                if(level >= 6){
	                    iconClass ='icvip icgoldvip icgold0'+ level;
	                }else{
	                    iconClass ='icvip icsuper0'+ level;
	                }
	                // iconClass ='icvip iczuan icz0'+ level;
	                break;
	            case 5:
	                iconClass ='icvip icsuper0'+ level;
	                break;
	            default:
	                iconClass ='icvip icvip0'+ level ;
	                break;
	        }
	        if(getCookie('vip_isvip') == 0){
	            //增加快鸟非会员显示快鸟图标
	            iconClass = iconClass + 'hui';
	        }
	        return iconClass;
	    }
	
	    /*
	     *用户会员身份
	     * return 用户会员名称
	     */
	    User.vipName = function(){
	        var name = '非会员';
	        var id = parseInt(getCookie('vas_type'));
	        var level = this.level();
	        if(!User.isVip() && !User.isOldvip()){
	            return name;
	        }
	        switch(id){
	            case 1:
	            case 2:
	                name = '迅雷普通会员';
	                break;
	            case 3:
	                if(level >= 6){
	                    name = '迅雷白金钻石会员';
	                }else{
	                    name = '迅雷白金会员';
	                }
	                break;
	            case 4:
	                if(level >= 6){
	                    name = '迅雷白金钻石会员';
	                }else{
	                    name = '迅雷超级会员';
	                }
	                // iconClass ='icvip iczuan icz0'+ level;
	                break;
	            case 5:
	               name = '迅雷超级会员';
	                break;
	            default:
	                name = '迅雷会员';
	                break;
	        }
	        name = name + 'VIP' + level;
	        if(getCookie('vip_isvip') == 0){
	
	            name = '过期' + name ;
	        }
	        return name;
	    }
	
	    /*
	     *用户到期时长剩余多少个月，向下取整
	     * return 剩余月份
	     */
	    User.levelMonth = function(){
	        var isVip = getCookie('vip_isvip'),
	            expiredays = getCookie('vip_expiredays');
	        if(isVip == 1){
	            return Math.floor(expiredays/31);
	        }
	        return 0 ;
	    }
	
	    User.payText = function(){
	
	        if(User.isStopVip()){
	            return '激活会员';
	        }
	        return getCookie('pay_tips') || '开通白金会员';
	    }
	
	    function _in_array(val, arr) {
	        for (var i in arr) {
	            if (arr[i] == val) {
	                return true;
	            }
	        }
	        return false;
	    }
	
	    //initUserInfo();
	    module.exports = User;


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(1);
	var backDiv = null,
	    popDiv = null;
	var msgbox_tpl = __webpack_require__(8);
	var active_cfg = window.active_cfg;
	function showmsg(msg, opts) {
	    exit();
	    opts = opts || {};
	    $('#act_msgbox_common').length ? popDiv = $('#act_msgbox_common') : popDiv = createpopDiv();
	    var btn_title = (opts.btn_title)|| opts.title || '确定';
	    var btn_class = (opts.btn_class) || '';
	    var btn_payid = (opts.btn_payid || opts.pid) || '';
	    var fn = opts.fn || opts.btn_fn || '';
	    if (btn_payid) {
	        btn_payid = 'pid="' + btn_payid + '"';
	    }
	    if(fn) {
	        opts.btn_href = opts.btn_href || 'javascript:;';
	    }
	    var btn_href = (opts.btn_href) || 'javascript:msgExit()';
	    var btn_target = (opts.btn_target == 1) ? '_blank' : '';
	    var clickid = "";
	    if (opts['boxTitle']) {
	        opts['boxTitle'] ? opts['boxTitle'] = opts['boxTitle'] : opts['boxTitle'] = '温馨提示';
	        popDiv.find('[name=boxTitle]').html(opts['boxTitle']);
	    } else {
	        popDiv.find('[name=boxTitle]').html('温馨提示');
	    }
	
	    popDiv.find("[name=msgbox_info]").html(msg);
	    var btn = popDiv.find('[name=box_btn]');
	    btn.replaceWith('<a class="act-pop-btn act-pop-btn-hot ' + btn_class + '" ' + clickid + ' ' + btn_payid + ' href="' + btn_href + '" name="box_btn" title="' + btn_title + '" target="' + btn_target + '">' + btn_title + '</a>');
	    if (opts && opts['close_href']) { //修改点击关闭的操作
	        var btn = popDiv.find('a.act-pop-close');
	        btn.replaceWith('<a href="' + opts['close_href'] + '" title="关闭" class="act-pop-close act_close_box">关闭</a>');
	    }
	    popDiv.find('[name=box_btn]').on('click', function(){
	        fn && fn();
	    });
	    createBackground(opts);
	    popDiv.show();
	    if (backDiv) {
	        backDiv.show();
	    }
	    refreshBind();
	};
	/**
	 * 显示指定id的div
	 * 调用方式：showDiv('showdiv',{opacity:0});
	 */
	showmsg.show = function(id, opts) {
	    exit();
	    opts = opts || {};
	    popDiv = $('#' + id);
	    popDiv.show();
	    createBackground(opts);
	    if (backDiv) {
	        backDiv.show();
	    }
	    if(opts.only) {
	        refreshBackground();
	    } else {
	        refreshBind();
	    }
	};
	
	showmsg.showErrorMsg = function(MSGID, opts) {
	    if (active_cfg && active_cfg['msg']) {
	        var MSG = active_cfg['msg'][MSGID];
	    }
	    if (MSG) {
	        opts = {
	            btn_title: MSG['btn_text'],
	            btn_href: MSG['btn_link'],
	            btn_target: MSG['btn_action'],
	            boxTitle: MSG['title'],
	            btn_class: MSG['btn_class'],
	            btn_payid: MSG['btn_payid']
	        };
	        showmsg(MSG['content'], opts);
	    } else {
	        showmsg(MSGID, opts);
	    }
	}
	
	function exit() {
	    if (popDiv) popDiv.hide();
	    if (backDiv) backDiv.remove();
	};
	
	function createpopDiv(opts) {
	    var style = (opts && opts.style) || 'common';
	    switch (style) {
	        case 'common':
	            popDiv = $(msgbox_tpl);
	            popDiv.appendTo('body');
	            break;
	        default:
	            break;
	    }
	    return popDiv;
	}
	
	/**
	 * 创建背景层
	 * 如果有指定背景层的id则直接显示该层
	 */
	function createBackground(opts) {
	    var opacity = (opts && opts.opacity) == undefined ? 40 : opts.opacity;
	    if (opacity > 0) {
	        backDiv = $('<div></div>');
	        backDiv.css({
	            backgroundColor: "black",
	            minWidth: '960px',
	            filter: "alpha(opacity=" + opacity + ")",
	            opacity: opacity / 100,
	            position: 'fixed',
	            left: 0,
	            top: 0,
	            right: 0,
	            bottom: 0,
	            zIndex: 100
	        });
	        backDiv.appendTo('body');
	    }
	}
	
	//绑定事件
	function refreshBind() {
	    $(window).resize(function() {
	        refreshBackground();
	        refreshPop();
	    });
	    refreshBackground();
	    refreshPop();
	}
	
	function refreshPop() {
	    var divHeight = parseInt(popDiv.outerHeight());
	    var divWidth = parseInt(popDiv.outerWidth());
	    var divLeft = parseInt((document.documentElement.clientWidth - divWidth) / 2);
	
	    var top = 0;
	    top = document.body.scrollTop || document.documentElement.scrollTop + 50;
	    var client_top = (document.documentElement.clientHeight - divHeight) / 2;
	
	    var divTop = parseInt((top) + ((document.documentElement.clientHeight - divHeight) / 2));
	
	    popDiv.css({
	        position: 'fixed',
	        top: client_top,
	        left: divLeft,
	        zIndex: 1002,
	        marginLeft: 0,
	        marginTop: 0
	    });
	}
	
	function refreshBackground() {
	    return
	    if (backDiv) {
	        var height = Math.max(document.body.scrollHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight);
	        backDiv.width(Math.min(document.body.scrollWidth, document.documentElement.scrollWidth));
	        backDiv.height(height);
	    }
	}
	
	showmsg.exit = window.msgExit = exit;
	module.exports = showmsg;

/***/ }),
/* 8 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"act-pop-box\" style=\"display:none;\" id=\"act_msgbox_common\"><a href=\"javascript:msgExit();\" title=\"关闭\" class=\"act-pop-close act_close_box\">关闭</a><div class=\"act-pop-p-hd\"><h3 class=\"act-pop-p-titl\" name=boxTitle>温馨提示</h3></div><div class=\"act-pop-p-bd\" style=\"min-height:80px\"><p class=\"act-pop-p-sec\"><span name=\"msgbox_info\"></span></p></div><div class=\"act-pop-p-ft\"><a class=\"act-pop-btn act-pop-btn-hot\" href=\"javascript:msgExit();\" name=\"box_btn\">确定</a></div></div>"

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(1);
	var _ = __webpack_require__(10);
	var user = __webpack_require__(6);
	var msgbox = __webpack_require__(7);
	var orderInterval = null;
	var orderCounter = 0;
	var typeData = '';
	var aidfrom = '';
	var tipsid = '';
	
	/*获取html片段*/
	function getHtml(url, data, callback) {
	    $.ajax({
	        url: url,
	        type: 'get',
	        data: data,
	        dataType: 'html'
	    }).done(function(json) {
	        callback(json);
	    }).fail(function() {
	        console.log("error");
	    });
	};
	
	var typeConfig = {
	    'originPay': {
	        'url': 'http://vip.xunlei.com/pagepiece/renew/original-pay.html',
	        'heightClass': 'pop_460x460',
	        'popid': 'hygw_tips_2'
	    },
	    'salePay': {
	        'url': 'http://vip.xunlei.com/pagepiece/renew/sale-pay.html',
	        'heightClass': 'pop_460x460',
	        'popid': 'hygw_tips_1'
	    },
	    'expiredMode1': {
	        'url': 'http://vip.xunlei.com/pagepiece/renew/expired-mode1.html',
	        'heightClass': 'pop_460x460',
	        'popid': 'hygw_tips_3'
	    },
	    'expiredMode2': {
	        'url': 'http://vip.xunlei.com/pagepiece/renew/expired-mode2.html',
	        'heightClass': 'pop_480x480',
	        'popid': 'hygw_tips_4'
	    }
	}
	
	
	/*
	 * 生成图片二维码
	 */
	function formSuperCode(data) {
	    var imgSrc = 'http://m.pay.xunlei.com/vippay/qrcode?'
	    for (var name in data) {
	        imgSrc += name + '=' + data[name] + '&';
	    }
	    return imgSrc + '_v=' + new Date().getTime();
	}
	
	function formSuperCodeJson(data, callback) {
	    var url = 'http://m.pay.xunlei.com/vippay/qrcode?';
	    // for (var name in data) {
	    //     url += name + '=' + data[name] + '&';
	    // }
	
	    $.ajax({
	        type: "get",
	        url: url,
	        data: data,
	        dataType: "jsonp",
	        success: function(rs) {
	            if (typeof callback == 'function') {
	                callback(rs);
	            }
	        }
	    });
	}
	
	/*
	 * 获取交易id
	 */
	function setTradeId(month) {
	    var vastype = getCookie('vas_type');
	    var submitMonth = month >= 10 ? month : '0' + month;
	    if(vastype == 5){
	        return tradeid = '14' + submitMonth;
	    }else{
	        return tradeid = '11' + submitMonth;
	    }
	}
	
	/*
	 * 动作时间操作
	 */
	function initEvent(type) {
	    $('#pay-list li').unbind().click(function(event) {
	        $('#pay-list li').removeClass('cho');
	        $(this).addClass('cho');
	        showPriceAndGetCode($(this).attr('data-month'), $(this).attr('data-price'), 'v_pc_hygw_push_tips_center', type);
	
	        /* Act on the event */
	    });
	
	    $('#renew-pop').on('click', '.link_refresh', function(){
	        $('#pay-list').find('li.cho').click();
	        $('#code-img').parent().find(".mask_off").hide();
	    }).on('click', '.btn_red', function(){
	        if(xla && xla.push){
	            xla.push({
	                type: 'event',
	                category: 'hygw_centertips',
	                action: 'centertips_click',
	                extdata: {
	                    pageid: typeData.popid,
	                    tipsid: tipsid,
	                    userid: getCookie('userid')
	                }
	            });
	        }
	    }).on('click', '.p_b_close', function(){
	        if(xla && xla.push){
	            xla.push({
	                type: 'event',
	                category: 'hygw_centertips',
	                action: 'centertips_close',
	                extdata: {
	                    pageid: typeData.popid,
	                    tipsid: tipsid,
	                    userid: getCookie('userid')
	                }
	            });
	        }
	    }).on('click', '.link_otherpay', function(){
	        if(getCookie('vas_type') == 5){  // 超级会员
	            window.open('https://pay.xunlei.com/pay.html?bizNo=baijin&mref=116&selectBizno=baijin&timeType=1412&selectWay=qrcode&referfrom=v_pc_hygw_push_tips_center');
	        }else{
	            window.open('https://pay.xunlei.com/pay.html?bizNo=baijin&mref=116&selectBizno=baijin&timeType=1112&selectWay=qrcode&referfrom=v_pc_hygw_push_tips_center');
	        }
	    });
	}
	
	/*
	 * 用户价格的显示
	 */
	function showPriceAndGetCode(month, money, referfrom, type) {
	    // perMonth = (money / month).toFixed(1);
	    perMonth = getCookie('vas_type') == 5 ? (month * 30 - money) : (month * 15 - money);
	    $('#total-moeny').text(money + '元');
	    $('#per-month').text('省' + perMonth + '元');
	    if (type = 1) {
	        var tradeid = setTradeId(month);
	        var data = {
	            qrcode: 1,
	            version: 1.5,
	            opid: 'web',
	            pid: 'pc',
	            userid: getCookie('userid'),
	            sessionid: getCookie('sessionid'),
	            mref: 105,
	            referfrom: referfrom,
	            days: '',
	            tradeid: tradeid,
	            auto: 0,
	            aidfrom: aidfrom
	        };
	
	        // if(month == 12 && getCookie('vas_type') != 5){
	        //     data = {
	        //         'version': 'v2.0',
	        //         'userid': getCookie('userid'),
	        //         'sessionid': getCookie('sessionid'),
	        //         'opid': 'web',
	        //         'activeid': '2003001',
	        //         'bizno': 'baijin',
	        //         'num': '13',
	        //         'rmb': '149',
	        //         'ext2': $.param({
	        //             actid: 'xl9minipage_bj',
	        //             pid: 'bj13_149'
	        //         }),
	        //         '_v': (new Date()).getTime(),
	        //         'mref': 105,
	        //         'referfrom': referfrom,
	        //         'aidfrom': aidfrom
	        //     };
	        // }
	        formSuperCodeJson(data, function(rs){
	            if (rs.data.code == 300) {
	                $('#code-loading').hide();
	                $('#code-img').attr('src', rs.data.qrcode).show();
	
	                try {
	                    clearInterval(orderInterval);
						orderCounter = 0;
						$('#code-img').parent().find(".mask_off").hide();
	                } catch (e) {
	
	                }
	
	                orderInterval = setInterval(function() {
						orderCounter ++;
						if(orderCounter > 400){  // 400  超过20分钟，则不再发送请求
							clearInterval(orderInterval);
							$('#code-img').parent().find(".mask_off").show();
							return;
						}
	                }, 3000);
	            }
	        });
	    }
	}
	
	/*
	 * 获取区间的类型
	 */
	function getType(day) {
	    if (15 >= day && 10 <= day) {
	        aidfrom = 'af_exp_10_15_qrcode';
	        tipsid = 700007;
	        return 1;
	    } else if (9 >= day && 4 <= day) {
	        aidfrom = 'af_exp_4_9_qrcode';
	        tipsid = 700005;
	        return 6;
	    } else if (3 >= day && 1 <= day) {
	        aidfrom = 'af_exp_1_3_qrcode';
	        tipsid = 700004;
	        return 2;
	    } else if (0 == day) {
	        aidfrom = 'bf_exp_0_qrcode';
	        tipsid = 700003;
	        return 3;
	    } else if (-3 <= day && -1 >= day) {
	        aidfrom = 'bf_exp_1_3_qrcode';
	        tipsid = 700002;
	        return 4;
	    } else if (-9 <= day && -4 >= day) {
	        aidfrom = 'bf_exp_4_9_qrcode';
	        tipsid = 700006;
	        return 5;
	    } else if (-15 <= day && -10 >= day) {
	        aidfrom = 'bf_exp_10_15_qrcode';
	        tipsid = 700001;
	        return 7;
	    } else {
	        return 0;
	    }
	}
	
	function init() {
	    var expiredays = getCookie('vip_expiredays'),
	        type = getType(expiredays),
	        isVip = getCookie('vip_isvip'),
	        renewPop = getCookie('renew_pop_' + getCookie('userid')),
	        popType;
	
	    if(type == 0){
	        return;
	    }
	
	    if (renewPop) {
	        var renewCookieArry = renewPop && renewPop.split('_') || [];
	        if (renewCookieArry[0] == isVip && renewCookieArry[1] == type) { //该规则配置下已经弹过弹窗
	            return;
	        } else {
	            if (renewCookieArry[0] != isVip) {
	                popType = getPopType(isVip);
	            } else {
	                popType = renewCookieArry[2]; //弹窗类型
	            }
	            showRenewPop(popType);
	            setPopCookie(isVip, type, popType);
	        }
	
	    } else {
	        popType = getPopType(isVip);
	        showRenewPop(popType);
	        setPopCookie(isVip, type, popType);
	    }
	}
	
	/*
	 * 用户显示弹窗
	 */
	function showRenewPop(type) {
	    typeData = typeConfig[type];
	    getHtml(typeData.url, {}, function(rs) {
	        var tpl = rs;
	        $('#renew-pop').addClass(typeData.heightClass).html((_.template(tpl))({
	            'avatar': user.avatar(),
	            'icon': user.vipIcon(),
	            'nameClass': user.isVip() ? '#C80000' : '#383838',
	            'userName': user.nickname(),
	            'expiredays': Math.abs(getCookie('vip_expiredays')),
	            'vastype': getCookie('vas_type')
	        }));
	        switch (type) {
	            case 'originPay':
	                initEvent(1);
	                $('#pay-list li').eq(0).click();
	                break;
	            case 'salePay':
	                showEndTime();
	                initEvent(1);
	                $('#pay-list li').eq(0).click();
	                break;
	            case 'expiredMode1':
	                initEvent(1);
	                $('#pay-list li').eq(0).click();
	                break;
	            case 'expiredMode2':
	                initEvent();
	                break;
	        }
	        // send_web_pv('adshow', {
	        //     'clickid': typeData.popid
	        // });
	        msgbox.showDiv('renew-pop');
	
	        if(xla && xla.push){
	            xla.push({
	                type: 'event',
	                category: 'hygw_centertips',
	                action: 'centertips_show',
	                extdata: {
	                    pageid: typeData.popid,
	                    tipsid: tipsid,
	                    userid: getCookie('userid')
	                }
	            });
	        }
	    })
	}
	
	/*
	 *设置弹窗的cookie
	 *@isvip 会员身份
	 *@type 显示的条件类型
	 *@poptype显示的弹窗类型
	 */
	function setPopCookie(isvip, type, poptype) {
	    setRealCookie('renew_pop_' + getCookie('userid'), isvip + '_' + type + '_' + poptype, 360);
	}
	
	/*
	 * 随机显示弹窗浮层样式
	 */
	function getPopType(isvip) {
	    var popType = '';
	    if (isvip == 1) {
	        popType = 'originPay';
	    } else {
	        popType = 'expiredMode1';
	    }
	    return popType;
	}
	
	/*
	 *倒计时
	 */
	function showEndTime() {
	    var ele = $('.countdown');
	    var vipExpDate = new Date(getCookie('vip_expiredate').replace(/-/g, '/'));
	    vipExpDate.setDate(vipExpDate.getDate() + 1);
	    var expireTime = (vipExpDate.getTime() - new Date().getTime())/1000;
	    var time = expireTime >= 0 ? expireTime : -1;
	    var interval = ele.data('interval') || 1000;
	    if (isNaN(time) || Math.floor(time) < 0) {
	        clearTimeout(window.run);
	        msgExit();
	    } else {
	        var dd = parseInt(time / 60 / 60 / 24);
	        var hh = parseInt((time - dd * 24 * 3600) / 60 / 60);
	        var mm = parseInt((time - dd * 24 * 3600 - hh * 3600) / 60);
	        var ss = parseInt(time - dd * 24 * 3600 - hh * 3600 - mm * 60);
	        var ms = parseInt(time * 100 - dd * 24 * 3600 * 100 - hh * 3600 * 100 - mm * 60 * 100 - ss * 100);
	        dd = dd > 9 ? dd + '' : '0' + dd;
	        hh = hh > 9 ? hh + '' : '0' + hh;
	        mm = mm > 9 ? mm + '' : '0' + mm;
	        ss = ss > 9 ? ss + '' : '0' + ss;
	        ms = ms + '';
	        if (ms.length == 1) {
	            ms = '0' + ms;
	        }
	
	        ele.html('<span class="colon">还剩</span><span class="num"><i>' + dd +
	            '</i></span><span class="colon">天</span><span class="num"><i>' + hh +
	            '</i></span><span class="colon">时</span><span class="num"><i>' + mm + '</i></span><span class="colon">分</span>');
	        time = (time * 1000 - interval) / 1000;
	        time = time.toFixed(2);
	        try {
	            clearTimeout(window.run);
	        } catch (e) {}
	        window.run = setTimeout(function() {
	            showEndTime();
	        }, interval);
	    }
	}
	
	module.exports = function() {
	    if (haslogin() && Math.abs(getCookie('vip_expiredays') || 100) <= 15 && (getCookie('is_vip') == 1 || getCookie('is_vip') == 0)) {
	        init();
	    }
	}


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;(function(){var root=this;var previousUnderscore=root._;var breaker={};var ArrayProto=Array.prototype,ObjProto=Object.prototype,FuncProto=Function.prototype;var push=ArrayProto.push,slice=ArrayProto.slice,concat=ArrayProto.concat,toString=ObjProto.toString,hasOwnProperty=ObjProto.hasOwnProperty;var nativeIsArray=Array.isArray,nativeKeys=Object.keys,nativeBind=FuncProto.bind;var _=function(obj){if(obj instanceof _)return obj;if(!(this instanceof _))return new _(obj);this._wrapped=obj};if(true){if(typeof module!=='undefined'&&module.exports){exports=module.exports=_}exports._=_}else{root._=_}_.VERSION='1.6.0';_.each=_.forEach=function(obj,iterator,context){if(obj==null)return obj;if(obj.length===+obj.length){for(var i=0,length=obj.length;i<length;i++){if(iterator.call(context,obj[i],i,obj)===breaker)return}}else{var keys=_.keys(obj);for(var i=0,length=keys.length;i<length;i++){if(iterator.call(context,obj[keys[i]],keys[i],obj)===breaker)return}}return obj};_.map=_.collect=function(obj,iterator,context){var results=[];if(obj==null)return results;_.each(obj,function(value,index,list){results.push(iterator.call(context,value,index,list))});return results};var reduceError='Reduce of empty array with no initial value';_.reduce=_.foldl=_.inject=function(obj,iterator,memo,context){var initial=arguments.length>2;if(obj==null)obj=[];_.each(obj,function(value,index,list){if(!initial){memo=value;initial=true}else{memo=iterator.call(context,memo,value,index,list)}});if(!initial)throw new TypeError(reduceError);return memo};_.reduceRight=_.foldr=function(obj,iterator,memo,context){var initial=arguments.length>2;if(obj==null)obj=[];var length=obj.length;if(length!==+length){var keys=_.keys(obj);length=keys.length}_.each(obj,function(value,index,list){index=keys?keys[--length]:--length;if(!initial){memo=obj[index];initial=true}else{memo=iterator.call(context,memo,obj[index],index,list)}});if(!initial)throw new TypeError(reduceError);return memo};_.find=_.detect=function(obj,predicate,context){var result;_.some(obj,function(value,index,list){if(predicate.call(context,value,index,list)){result=value;return true}});return result};_.filter=_.select=function(obj,predicate,context){var results=[];if(obj==null)return results;_.each(obj,function(value,index,list){if(predicate.call(context,value,index,list))results.push(value)});return results};_.reject=function(obj,predicate,context){return _.filter(obj,_.negate(predicate),context)};_.every=_.all=function(obj,predicate,context){predicate||(predicate=_.identity);var result=true;if(obj==null)return result;_.each(obj,function(value,index,list){if(!(result=result&&predicate.call(context,value,index,list)))return breaker});return!!result};_.some=_.any=function(obj,predicate,context){predicate||(predicate=_.identity);var result=false;if(obj==null)return result;_.each(obj,function(value,index,list){if(result||(result=predicate.call(context,value,index,list)))return breaker});return!!result};_.contains=_.include=function(obj,target){if(obj==null)return false;if(obj.length===+obj.length)return _.indexOf(obj,target)>=0;return _.some(obj,function(value){return value===target})};_.invoke=function(obj,method){var args=slice.call(arguments,2);var isFunc=_.isFunction(method);return _.map(obj,function(value){return(isFunc?method:value[method]).apply(value,args)})};_.pluck=function(obj,key){return _.map(obj,_.property(key))};_.where=function(obj,attrs){return _.filter(obj,_.matches(attrs))};_.findWhere=function(obj,attrs){return _.find(obj,_.matches(attrs))};_.max=function(obj,iterator,context){var result=-Infinity,lastComputed=-Infinity,value,computed;if(!iterator&&_.isArray(obj)){for(var i=0,length=obj.length;i<length;i++){value=obj[i];if(value>result){result=value}}}else{_.each(obj,function(value,index,list){computed=iterator?iterator.call(context,value,index,list):value;if(computed>lastComputed||(computed===-Infinity&&result===-Infinity)){result=value;lastComputed=computed}})}return result};_.min=function(obj,iterator,context){var result=Infinity,lastComputed=Infinity,value,computed;if(!iterator&&_.isArray(obj)){for(var i=0,length=obj.length;i<length;i++){value=obj[i];if(value<result){result=value}}}else{_.each(obj,function(value,index,list){computed=iterator?iterator.call(context,value,index,list):value;if(computed<lastComputed||(computed===Infinity&&result===Infinity)){result=value;lastComputed=computed}})}return result};_.shuffle=function(obj){var rand;var index=0;var shuffled=[];_.each(obj,function(value){rand=_.random(index++);shuffled[index-1]=shuffled[rand];shuffled[rand]=value});return shuffled};_.sample=function(obj,n,guard){if(n==null||guard){if(obj.length!==+obj.length)obj=_.values(obj);return obj[_.random(obj.length-1)]}return _.shuffle(obj).slice(0,Math.max(0,n))};var lookupIterator=function(value,context){if(value==null)return _.identity;if(!_.isFunction(value))return _.property(value);if(!context)return value;return function(){return value.apply(context,arguments)}};_.sortBy=function(obj,iterator,context){iterator=lookupIterator(iterator,context);return _.pluck(_.map(obj,function(value,index,list){return{value:value,index:index,criteria:iterator(value,index,list)}}).sort(function(left,right){var a=left.criteria;var b=right.criteria;if(a!==b){if(a>b||a===void 0)return 1;if(a<b||b===void 0)return-1}return left.index-right.index}),'value')};var group=function(behavior){return function(obj,iterator,context){var result={};iterator=lookupIterator(iterator,context);_.each(obj,function(value,index){var key=iterator(value,index,obj);behavior(result,value,key)});return result}};_.groupBy=group(function(result,value,key){_.has(result,key)?result[key].push(value):result[key]=[value]});_.indexBy=group(function(result,value,key){result[key]=value});_.countBy=group(function(result,value,key){_.has(result,key)?result[key]++:result[key]=1});_.sortedIndex=function(array,obj,iterator,context){iterator=lookupIterator(iterator,context);var value=iterator(obj);var low=0,high=array.length;while(low<high){var mid=(low+high)>>>1;iterator(array[mid])<value?low=mid+1:high=mid}return low};_.toArray=function(obj){if(!obj)return[];if(_.isArray(obj))return slice.call(obj);if(obj.length===+obj.length)return _.map(obj,_.identity);return _.values(obj)};_.size=function(obj){if(obj==null)return 0;return(obj.length===+obj.length)?obj.length:_.keys(obj).length};_.first=_.head=_.take=function(array,n,guard){if(array==null)return void 0;if((n==null)||guard)return array[0];if(n<0)return[];return slice.call(array,0,n)};_.initial=function(array,n,guard){return slice.call(array,0,Math.max(0,array.length-(n==null||guard?1:n)))};_.last=function(array,n,guard){if(array==null)return void 0;if((n==null)||guard)return array[array.length-1];return slice.call(array,Math.max(array.length-n,0))};_.rest=_.tail=_.drop=function(array,n,guard){return slice.call(array,(n==null)||guard?1:n)};_.compact=function(array){return _.filter(array,_.identity)};var flatten=function(input,shallow,strict,output){if(shallow&&_.every(input,_.isArray)){return concat.apply(output,input)}for(var i=0,length=input.length;i<length;i++){var value=input[i];if(!_.isArray(value)&&!_.isArguments(value)){if(!strict)output.push(value)}else if(shallow){push.apply(output,value)}else{flatten(value,shallow,strict,output)}}return output};_.flatten=function(array,shallow){return flatten(array,shallow,false,[])};_.without=function(array){return _.difference(array,slice.call(arguments,1))};_.partition=function(obj,predicate,context){predicate=lookupIterator(predicate,context);var pass=[],fail=[];_.each(obj,function(value,key,obj){(predicate(value,key,obj)?pass:fail).push(value)});return[pass,fail]};_.uniq=_.unique=function(array,isSorted,iterator,context){if(array==null)return[];if(_.isFunction(isSorted)){context=iterator;iterator=isSorted;isSorted=false}var result=[];var seen=[];for(var i=0,length=array.length;i<length;i++){var value=array[i];if(iterator)value=iterator.call(context,value,i,array);if(isSorted?(!i||seen!==value):!_.contains(seen,value)){if(isSorted)seen=value;else seen.push(value);result.push(array[i])}}return result};_.union=function(){return _.uniq(flatten(arguments,true,true,[]))};_.intersection=function(array){if(array==null)return[];var result=[];var argsLength=arguments.length;for(var i=0,length=array.length;i<length;i++){var item=array[i];if(_.contains(result,item))continue;for(var j=1;j<argsLength;j++){if(!_.contains(arguments[j],item))break}if(j===argsLength)result.push(item)}return result};_.difference=function(array){var rest=flatten(slice.call(arguments,1),true,true,[]);return _.filter(array,function(value){return!_.contains(rest,value)})};_.zip=function(){var length=_.max(_.pluck(arguments,'length').concat(0));var results=new Array(length);for(var i=0;i<length;i++){results[i]=_.pluck(arguments,''+i)}return results};_.object=function(list,values){if(list==null)return{};var result={};for(var i=0,length=list.length;i<length;i++){if(values){result[list[i]]=values[i]}else{result[list[i][0]]=list[i][1]}}return result};_.indexOf=function(array,item,isSorted){if(array==null)return-1;var i=0,length=array.length;if(isSorted){if(typeof isSorted=='number'){i=(isSorted<0?Math.max(0,length+isSorted):isSorted)}else{i=_.sortedIndex(array,item);return array[i]===item?i:-1}}for(;i<length;i++)if(array[i]===item)return i;return-1};_.lastIndexOf=function(array,item,from){if(array==null)return-1;var i=from==null?array.length:from;while(i--)if(array[i]===item)return i;return-1};_.range=function(start,stop,step){if(arguments.length<=1){stop=start||0;start=0}step=arguments[2]||1;var length=Math.max(Math.ceil((stop-start)/step),0);var idx=0;var range=new Array(length);while(idx<length){range[idx++]=start;start+=step}return range};var ctor=function(){};_.bind=function(func,context){var args,bound;if(nativeBind&&func.bind===nativeBind)return nativeBind.apply(func,slice.call(arguments,1));if(!_.isFunction(func))throw new TypeError('Bind must be called on a function');args=slice.call(arguments,2);return bound=function(){if(!(this instanceof bound))return func.apply(context,args.concat(slice.call(arguments)));ctor.prototype=func.prototype;var self=new ctor;ctor.prototype=null;var result=func.apply(self,args.concat(slice.call(arguments)));if(Object(result)===result)return result;return self}};_.partial=function(func){var boundArgs=slice.call(arguments,1);return function(){var position=0;var args=boundArgs.slice();for(var i=0,length=args.length;i<length;i++){if(args[i]===_)args[i]=arguments[position++]}while(position<arguments.length)args.push(arguments[position++]);return func.apply(this,args)}};_.bindAll=function(obj){var funcs=slice.call(arguments,1);if(funcs.length===0)throw new Error('bindAll must be passed function names');_.each(funcs,function(f){obj[f]=_.bind(obj[f],obj)});return obj};_.memoize=function(func,hasher){var memo={};hasher||(hasher=_.identity);return function(){var key=hasher.apply(this,arguments);return _.has(memo,key)?memo[key]:(memo[key]=func.apply(this,arguments))}};_.delay=function(func,wait){var args=slice.call(arguments,2);return setTimeout(function(){return func.apply(null,args)},wait)};_.defer=function(func){return _.delay.apply(_,[func,1].concat(slice.call(arguments,1)))};_.throttle=function(func,wait,options){var context,args,result;var timeout=null;var previous=0;options||(options={});var later=function(){previous=options.leading===false?0:_.now();timeout=null;result=func.apply(context,args);context=args=null};return function(){var now=_.now();if(!previous&&options.leading===false)previous=now;var remaining=wait-(now-previous);context=this;args=arguments;if(remaining<=0||remaining>wait){clearTimeout(timeout);timeout=null;previous=now;result=func.apply(context,args);context=args=null}else if(!timeout&&options.trailing!==false){timeout=setTimeout(later,remaining)}return result}};_.debounce=function(func,wait,immediate){var timeout,args,context,timestamp,result;var later=function(){var last=_.now()-timestamp;if(last<wait&&last>0){timeout=setTimeout(later,wait-last)}else{timeout=null;if(!immediate){result=func.apply(context,args);context=args=null}}};return function(){context=this;args=arguments;timestamp=_.now();var callNow=immediate&&!timeout;if(!timeout){timeout=setTimeout(later,wait)}if(callNow){result=func.apply(context,args);context=args=null}return result}};_.once=function(func){var ran=false,memo;return function(){if(ran)return memo;ran=true;memo=func.apply(this,arguments);func=null;return memo}};_.wrap=function(func,wrapper){return _.partial(wrapper,func)};_.negate=function(predicate){return function(){return!predicate.apply(this,arguments)}};_.compose=function(){var funcs=arguments;return function(){var args=arguments;for(var i=funcs.length-1;i>=0;i--){args=[funcs[i].apply(this,args)]}return args[0]}};_.after=function(times,func){return function(){if(--times<1){return func.apply(this,arguments)}}};_.keys=function(obj){if(!_.isObject(obj))return[];if(nativeKeys)return nativeKeys(obj);var keys=[];for(var key in obj)if(_.has(obj,key))keys.push(key);return keys};_.values=function(obj){var keys=_.keys(obj);var length=keys.length;var values=new Array(length);for(var i=0;i<length;i++){values[i]=obj[keys[i]]}return values};_.pairs=function(obj){var keys=_.keys(obj);var length=keys.length;var pairs=new Array(length);for(var i=0;i<length;i++){pairs[i]=[keys[i],obj[keys[i]]]}return pairs};_.invert=function(obj){var result={};var keys=_.keys(obj);for(var i=0,length=keys.length;i<length;i++){result[obj[keys[i]]]=keys[i]}return result};_.functions=_.methods=function(obj){var names=[];for(var key in obj){if(_.isFunction(obj[key]))names.push(key)}return names.sort()};_.extend=function(obj){if(!_.isObject(obj))return obj;_.each(slice.call(arguments,1),function(source){for(var prop in source){obj[prop]=source[prop]}});return obj};_.pick=function(obj,iterator,context){var result={};if(_.isFunction(iterator)){for(var key in obj){var value=obj[key];if(iterator.call(context,value,key,obj))result[key]=value}}else{var keys=concat.apply([],slice.call(arguments,1));for(var i=0,length=keys.length;i<length;i++){var key=keys[i];if(key in obj)result[key]=obj[key]}}return result};_.omit=function(obj,iterator,context){var keys;if(_.isFunction(iterator)){iterator=_.negate(iterator)}else{keys=_.map(concat.apply([],slice.call(arguments,1)),String);iterator=function(value,key){return!_.contains(keys,key)}}return _.pick(obj,iterator,context)};_.defaults=function(obj){if(!_.isObject(obj))return obj;_.each(slice.call(arguments,1),function(source){for(var prop in source){if(obj[prop]===void 0)obj[prop]=source[prop]}});return obj};_.clone=function(obj){if(!_.isObject(obj))return obj;return _.isArray(obj)?obj.slice():_.extend({},obj)};_.tap=function(obj,interceptor){interceptor(obj);return obj};var eq=function(a,b,aStack,bStack){if(a===b)return a!==0||1/a==1/b;if(a==null||b==null)return a===b;if(a instanceof _)a=a._wrapped;if(b instanceof _)b=b._wrapped;var className=toString.call(a);if(className!=toString.call(b))return false;switch(className){case'[object String]':return a==String(b);case'[object Number]':return a!=+a?b!=+b:(a==0?1/a==1/b:a==+b);case'[object Date]':case'[object Boolean]':return+a==+b;case'[object RegExp]':return a.source==b.source&&a.global==b.global&&a.multiline==b.multiline&&a.ignoreCase==b.ignoreCase}if(typeof a!='object'||typeof b!='object')return false;var length=aStack.length;while(length--){if(aStack[length]==a)return bStack[length]==b}var aCtor=a.constructor,bCtor=b.constructor;if(aCtor!==bCtor&&!(_.isFunction(aCtor)&&(aCtor instanceof aCtor)&&_.isFunction(bCtor)&&(bCtor instanceof bCtor))&&('constructor'in a&&'constructor'in b)){return false}aStack.push(a);bStack.push(b);var size=0,result=true;if(className=='[object Array]'){size=a.length;result=size==b.length;if(result){while(size--){if(!(result=eq(a[size],b[size],aStack,bStack)))break}}}else{for(var key in a){if(_.has(a,key)){size++;if(!(result=_.has(b,key)&&eq(a[key],b[key],aStack,bStack)))break}}if(result){for(key in b){if(_.has(b,key)&&!(size--))break}result=!size}}aStack.pop();bStack.pop();return result};_.isEqual=function(a,b){return eq(a,b,[],[])};_.isEmpty=function(obj){if(obj==null)return true;if(_.isArray(obj)||_.isString(obj)||_.isArguments(obj))return obj.length===0;for(var key in obj)if(_.has(obj,key))return false;return true};_.isElement=function(obj){return!!(obj&&obj.nodeType===1)};_.isArray=nativeIsArray||function(obj){return toString.call(obj)=='[object Array]'};_.isObject=function(obj){return obj===Object(obj)};_.each(['Arguments','Function','String','Number','Date','RegExp'],function(name){_['is'+name]=function(obj){return toString.call(obj)=='[object '+name+']'}});if(!_.isArguments(arguments)){_.isArguments=function(obj){return!!(obj&&_.has(obj,'callee'))}}if(true){_.isFunction=function(obj){return typeof obj==='function'}}_.isFinite=function(obj){return isFinite(obj)&&!isNaN(parseFloat(obj))};_.isNaN=function(obj){return _.isNumber(obj)&&obj!=+obj};_.isBoolean=function(obj){return obj===true||obj===false||toString.call(obj)=='[object Boolean]'};_.isNull=function(obj){return obj===null};_.isUndefined=function(obj){return obj===void 0};_.has=function(obj,key){return hasOwnProperty.call(obj,key)};_.noConflict=function(){root._=previousUnderscore;return this};_.identity=function(value){return value};_.constant=function(value){return function(){return value}};_.noop=function(){};_.property=function(key){return function(obj){return obj[key]}};_.matches=function(attrs){return function(obj){if(obj==null)return _.isEmpty(attrs);if(obj===attrs)return true;for(var key in attrs)if(attrs[key]!==obj[key])return false;return true}};_.times=function(n,iterator,context){var accum=Array(Math.max(0,n));for(var i=0;i<n;i++)accum[i]=iterator.call(context,i);return accum};_.random=function(min,max){if(max==null){max=min;min=0}return min+Math.floor(Math.random()*(max-min+1))};_.now=Date.now||function(){return new Date().getTime()};var entityMap={escape:{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#x27;'}};entityMap.unescape=_.invert(entityMap.escape);var entityRegexes={escape:new RegExp('['+_.keys(entityMap.escape).join('')+']','g'),unescape:new RegExp('('+_.keys(entityMap.unescape).join('|')+')','g')};_.each(['escape','unescape'],function(method){_[method]=function(string){if(string==null)return'';return(''+string).replace(entityRegexes[method],function(match){return entityMap[method][match]})}});_.result=function(object,property){if(object==null)return void 0;var value=object[property];return _.isFunction(value)?object[property]():value};_.mixin=function(obj){_.each(_.functions(obj),function(name){var func=_[name]=obj[name];_.prototype[name]=function(){var args=[this._wrapped];push.apply(args,arguments);return result.call(this,func.apply(_,args))}})};var idCounter=0;_.uniqueId=function(prefix){var id=++idCounter+'';return prefix?prefix+id:id};_.templateSettings={evaluate:/<%([\s\S]+?)%>/g,interpolate:/<%=([\s\S]+?)%>/g,escape:/<%-([\s\S]+?)%>/g};var noMatch=/(.)^/;var escapes={"'":"'",'\\':'\\','\r':'r','\n':'n','\u2028':'u2028','\u2029':'u2029'};var escaper=/\\|'|\r|\n|\u2028|\u2029/g;var escapeChar=function(match){return'\\'+escapes[match]};_.template=function(text,data,settings){settings=_.defaults({},settings,_.templateSettings);var matcher=new RegExp([(settings.escape||noMatch).source,(settings.interpolate||noMatch).source,(settings.evaluate||noMatch).source].join('|')+'|$','g');var index=0;var source="__p+='";text.replace(matcher,function(match,escape,interpolate,evaluate,offset){source+=text.slice(index,offset).replace(escaper,escapeChar);index=offset+match.length;if(escape){source+="'+\n((__t=("+escape+"))==null?'':_.escape(__t))+\n'"}else if(interpolate){source+="'+\n((__t=("+interpolate+"))==null?'':__t)+\n'"}else if(evaluate){source+="';\n"+evaluate+"\n__p+='"}return match});source+="';\n";if(!settings.variable)source='with(obj||{}){\n'+source+'}\n';source="var __t,__p='',__j=Array.prototype.join,"+"print=function(){__p+=__j.call(arguments,'');};\n"+source+"return __p;\n";try{var render=new Function(settings.variable||'obj','_',source)}catch(e){e.source=source;throw e;}if(data)return render(data,_);var template=function(data){return render.call(this,data,_)};var argument=settings.variable||'obj';template.source='function('+argument+'){\n'+source+'}';return template};_.chain=function(obj){return _(obj).chain()};var result=function(obj){return this._chain?_(obj).chain():obj};_.mixin(_);_.each(['pop','push','reverse','shift','sort','splice','unshift'],function(name){var method=ArrayProto[name];_.prototype[name]=function(){var obj=this._wrapped;method.apply(obj,arguments);if((name=='shift'||name=='splice')&&obj.length===0)delete obj[0];return result.call(this,obj)}});_.each(['concat','join','slice'],function(name){var method=ArrayProto[name];_.prototype[name]=function(){return result.call(this,method.apply(this._wrapped,arguments))}});_.extend(_.prototype,{chain:function(){this._chain=true;return this},value:function(){return this._wrapped}}); true?!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return _}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):typeof exports==='object'?module.exports=_:window._=_}).call(this);

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(1);
	var user = __webpack_require__(6);
	var head = {
	    init: function(){
	         if (location.host === 'vip.xunlei.com') {
	            head.vip()
	         }else if(location.host === 'act.vip.xunlei.com'){
	            head.knAndAct()
	         }else if (location.host === 'act.jsq.xunlei.com'){
	            head.JSQ()
	         }
	    },
	    vip: function(){
	        var loginTpl = $('#loginAfter_tpl').html();
	        $('#header-unlogin').hide();
	        var data = {
	            'avatar': user.avatar(),
	            'icon': user.vipIcon(),
	            'vipName': user.vipName(),
	            'iconUrl': user.iconUrl(),
	            'nameClass': user.isVip() ? '#C80000' : '#383838',
	            'userName': user.nickname(),
	            'expireTip': getVipExpireTimeTip()
	        }
	        $('#header-login').html((_.template(loginTpl))(data)).show();
	        $('.pay-vip').html(user.payText());
	
	        //获取会员过期时间提示
	        function getVipExpireTimeTip() {
	            var expireDays = Math.abs(getCookie('vip_expiredays'));
	            var tipStr;
	            if (user.isStopVip()) {
	                return '您的会员已暂停';
	            }
	
	            if (user.isMobileVip()) {
	                return '您当前是手机包月会员';
	            }
	
	            if (user.isOldvip()) {
	                if (expireDays < 30) {
	                    tipStr = '过期会员成长值每日降10点';
	                } else {
	                    tipStr = '您的会员已过期';
	                }
	            } else if (user.isVip()) {
	                if (expireDays == 0) {
	                    tipStr = '你的会员今日到期，记得续费哦~';
	                } else if (expireDays < 15) {
	                    tipStr = '你的会员将于' + expireDays + '天后到期';
	                } else {
	                    tipStr = '会员有效期' + user.expiredate();
	                }
	            } else {
	                tipStr = '点亮会员，尊享30多项特权';
	            }
	            return tipStr;
	
	        }
	    },
	    knAndAct: function(){
	        $('#header-unlogin').hide();
	        var head = $('#header-login').show();
	        $('#vip-icon').removeClass().addClass(user.vipIcon());
	        head.find('em').find('a').eq(0).removeClass().addClass(user.isVip() ? 'username clr_red' : 'username').html('hi,' + user.nickname());
	        head.find('img').attr('src', 'http://img.ucenter.xunlei.com/usrimg/' + getCookie('userid') + '/50x50');
	        //兼容快鸟
	        $('.j_header_userName').html(user.nickname());
	        var timer;
	        $('#header-login').hover(function(event) {
	            timer && clearTimeout(timer);
	            $(this).find('em.p_selfcon').show();
	            return false;
	        }, function(event) {
	            timer = setTimeout(function() {
	                $('em.p_selfcon').hide();
	            }, 300)
	        })
	    },
	    JSQ: function(){
	         //console.log('initJSQ')
	        var _div = $("#div_header"),
	            _span = $("#span_userinfo"),
	            nickname = user.nickname() , //昵称
	            userid = getCookie("userid"),
	            userno = user.xlUsername(),
	            jsq_growvalue = getCookie("jsq_growvalue") ? getCookie("jsq_growvalue") : 0,
	            jsq_expiredate = getCookie("jsq_expiredate"),
	            jsq_level = getCookie("jsq_level"),
	            jsq_paytype = getCookie("jsq_paytype"),
	            jsq_type = getCookie("jsq_type") ? getCookie("jsq_type") : 0,
	            jsq_score = getCookie("jsq_score") ? getCookie("jsq_score") : 0,
	            jsq_expiretype = getCookie("jsq_expiretype"),
	            jsq_trialvip = getCookie("jsq_trialvip") ? getCookie("jsq_trialvip") : 0,
	            jsq_trialexpire = getCookie("jsq_trialexpire") ? getCookie("jsq_trialexpire") : 0;
	            // console.log(jsq_trialvip)
	        function _init_info() {
	            _div.find(".unlogin").hide(); //隐藏登录按钮
	            _div.find(".logined").show(); //展示用户信息
	            _div.find(".userinfo").hover(
	                function() {
	                    try {
	                        clearTimeout(accountHoverTimer)
	                    } catch (e) {};
	                    _div.find(".infopop").show();
	                    $(this).addClass('userinfo_hover');
	                },
	                function() {
	                    $(this).removeClass('userinfo_hover');
	                    accountHoverTimer = setTimeout(function() {
	                        _div.find(".infopop").hide();
	                    }, 50);
	                });
	        }
	
	        function _isyear() {
	            //年会员
	            if (jsq_paytype == 5 || jsq_paytype == 105) {
	                return true;
	            } else {
	                return false;
	            }
	        }
	
	
	        function _init_pop() {
	            var _grow, _nickname, _isyear, _tmp, _timeup = '',
	                _icon;
	            var _top = _div.find('.popcont .top');
	            var _btm = _div.find('.popcont .btm');
	            var _headimg = '<a href="http://dynamic.i.xunlei.com/user" target="_blank" title="" class="face spr_head"><img src="http://img.ucenter.xunlei.com/usrimg/' + userid + '/50x50" alt="" /></a>';
	            if (nickname.length > 5) {
	                nickname = nickname.substring(0, 5) + '...';
	            }
	            _nickname = jsq_trialvip == 1 || jsq_type > 0 ? '<b >' + nickname + '</b>' : nickname;
	
	            var _nickinfo = '<p>亲爱的' + _nickname + '</p>';
	
	            if (jsq_type > 0) {
	                //会员
	                if (jsq_type == 1) {
	                    //高级会员
	                    _grow = '<p class="ictq clear"><a href="http://jsq.xunlei.com/grown.html" target="_blank" class="fl slv_icon slv' + jsq_level + '"></a></p>';
	                    _icon = 'degree_icon svip' + jsq_level + ' fl';
	                } else {
	                    //普通会员
	                    _grow = '<p class="ictq clear"><a href="http://jsq.xunlei.com/grown.html" target="_blank" class="fl lv_icon lv' + jsq_level + '"></a></p>';
	                    _icon = "degree_icon vip" + jsq_level + " fl";
	                }
	                _timeup += '<p class="time"><a href="http://vip.xunlei.com/vip_service/orderlist.html" target="_blank">' + jsq_expiredate + '到期</a></p>';
	            } else {
	                if (jsq_trialvip == 1) {
	                    //体验会员
	                    jsq_trialexpire = jsq_trialexpire.split(" ");
	                    _timeup += '<p class="time"><a href="http://vip.xunlei.com/vip_service/orderlist.html" target="_blank">' + jsq_trialexpire[0] + '到期</a></p>';
	                    $("#trialvip_icon").show();
	                }
	
	                //过期或非会员
	                if (jsq_expiretype == 1) {
	                    _grow = '<p class="ictq clear"><a href="http://jsq.xunlei.com/grown.html" target="_blank" class="fl slvhui_icon slv' + jsq_level + '"></a></p>';
	                    _icon = 'degreehui_icon svip' + jsq_level + ' fl';
	                } else {
	                    _grow = '<p class="ictq clear"><a href="http://jsq.xunlei.com/grown.html" target="_blank" class="fl lvhui_icon lv' + jsq_level + '"></a></p>';
	                    _icon = 'degreeviphui_icon viphui' + jsq_level + ' fl';
	                }
	            }
	
	            _tmp = _headimg + _nickinfo + _grow + _timeup;
	            _top.html(_tmp);
	            _span.removeClass().addClass(_icon);
	
	            _div.find(".username").html(_nickname);
	                        // alert(_nickname)
	            $("#first_score").html(jsq_score);
	            $("#first_grown").html(jsq_growvalue);
	        }
	         function _initDomInfo(){
	              $('#act_nickname,.act_nickname,[name=act_nickname]').text(vipUser.nickname());
	              $('#act_userid,.act_userid,[name=act_userid]').text(vipUtils.getCookie('userid'));
	              if(window.ACTCONFIG && window.ACTCONFIG.open_vip_link)
	              $('#header_open_vip_link').attr('href', window.ACTCONFIG.open_vip_link+'?referfrom='+referfrom);
	              $('.unlogin').hide();
	              $('.logined').show();
	            }
	
	
	        _init_info();
	        _init_pop();
	        _initDomInfo();
	    }
	}
	
	module.exports = head


/***/ }),
/* 12 */
/***/ (function(module, exports) {

	var template = function(id) {
		return cache[id] || (cache[id] = build(getTpl(id)));
	};
	
	var cache = {};
	
	var build = function(tpl){
		return function(data){
			var compiler = compile(tpl);
			return new compiler(data).toString();
		}
	}
	
	template.build = build;
	
	var getTpl = function(id) {
		var el = document.getElementById(id);
		return el ? el.innerHTML : '';
	}
	
	var toString = function(value) {
		var type = typeof value;
		if (type !== 'string') {
			if (type === 'number') {
				value += '';
			} else if (type === 'function') {
				value = toString(value.call(value));
			} else {
				value = '';
			}
		}
		return value;
	};
	
	var escapeMap = {
		"<": "&#60;",
		">": "&#62;",
		'"': "&#34;",
		"'": "&#39;",
		"&": "&#38;"
	};
	
	var escapeFn = function(s) {
		return escapeMap[s];
	};
	
	var escape = function(content) {
		return toString(content).replace(/&(?![\w#]+;)|[<>"']/g, escapeFn);
	};
	
	var isArray = Array.isArray || function(obj) {
		return Object.prototype.toString.call(obj) === '[object Array]';
	};
	
	var each = function(data, callback) {
		var i, len, count = 0;
		if (isArray(data)) {
			for (i = 0, len = data.length; i < len; i++) {
				callback.call(data, data[i], i, data, i);
			}
		} else {
			for (i in data) {
				callback.call(data, data[i], i, data, count);
				count++;
			}
		}
	};
	
	var compile = template.compile = function(source, data) {
	
		var isNewEngine = ''.trim;
		var replaces = isNewEngine ? ["$o='';", "$o+=", ";", "$o"] : ["$o=[];", "$o.push(", ");", "$o.join('')"];
		var headerCode = "'use strict';var $e=this.$e,$f=this.$f,";
		var mainCode = replaces[0];
		var footerCode = "return new String(" + replaces[3] + ");"
	
		each(source.split("{{"), function(code, index) {
			code = code.split("}}");
			var $0 = code[0];
			var $1 = code[1];
			var len = code.length;
			if (code.length === 1) {
				mainCode += html($0);
			} else if (len === 2) {
				mainCode += logic($0);
				if ($1) {
					mainCode += html($1);
				}
			}
		});
	
		function stringify(code) {
			return "'" + code
				.replace(/('|\\)/g, '\\$1')
				.replace(/\r/g, '\\r')
				.replace(/\n/g, '\\n') + "'";
		}
	
		function html(code) {
			if (code) {
				code = replaces[1] + stringify(code) + replaces[2];
			}
			return code;
		}
	
		function logic(code) {
			code = code.replace(/^\s+|\s+$/, '');
			var split = code.split(/\s+/);
			var key = split.shift();
			var args = split.join(' ');
			switch (key) {
				case 'if':
					code = 'if(' + args + '){';
					break;
	
				case 'else':
					code = '}else{';
					break;
	
				case 'elseif':
					code = '}else if(' + args + '){';
					break;
	
				case '/if':
					code = '};';
					break;
	
				case 'for':
					split[0] = split[0] || '$d';
					split[1] = split[1] || '$v';
					split[2] = split[2] || '$k';
					code = '$f(' + split.shift() + ',function(' + split.join() + '){';
					break;
	
				case '/for':
					code = '});';
					break;
	
				case 'eval':
					code = args + ';';
					break;
	
				case '#':
					code = replaces[1] + "$e(" + code + ")" + replaces[2];
					break;
	
				default:
					code = replaces[1] + code + replaces[2];
					break;
			}
			return code;
		}
		var compiler = new Function("$d", headerCode + mainCode + footerCode);
		compiler.prototype.$e = escape;
		compiler.prototype.$f = each;
		return compiler;
	}
	
	module.exports = template;

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(1);
	$(function() {
		(function() {
			var xla = window.xla || (window.xla = []);
			xla.push({
				type: 'config',
				appid: 20009,
				secret: 'a8d1fc968b2fe1fe21bfe8f2abc4ba3a'
			});
			var s = document.createElement('script');
			s.src = '//res-etl-ssl.xunlei.com/v1.0.0/xla.min.js';
			s.async = true;
			document.getElementsByTagName('head')[0].appendChild(s);
		})();
	
		(function() {
			var s = document.createElement("script");
			s.src = "//hm.baidu.com/hm.js?be94a17b28798d3dc61eb511641cdd9a";
			s.async = true;
			document.getElementsByTagName('head')[0].appendChild(s);
		})();
	})
	
	function tj(id) {
		if (!id) {
			return;
		}
		window.habo_aid = id;
		var s = document.createElement('script');
		s.src = '/static/com/pv_click_v2.js';
		s.async = true;
		document.getElementsByTagName('head')[0].appendChild(s);
	
		
	}
	
	module.exports = tj;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(1);
	var msgbox = __webpack_require__(7);
	var logisticsId = 'act_logistics_popbox';
	var tpl = __webpack_require__(15);
	var template = __webpack_require__(12);
	var list = [];
	var totalLogisticsLength = 0;
	var tips = '';
	var l_status = false;
	var actid = active_cfg.base.actid;
	
	function LogisticsList(url) {
	    if (!haslogin()) {
	        login();
	        return;
	    }
	    if (l_status) {
	        return;
	    }
	    url = url || ('http://dyactive2.vip.xunlei.com/iface/?action=logininit&actid=' + actid);
	    l_status = true;
	    $.jsonp(url, function(rs) {
	        l_status = false;
	        var result = parseInt(rs.result);
	        if (result == 0) {
	            list = rs.data.prizelist || [];
	            var listData = [];
	            for (var k = 0, len = list.length; k < len; k++) {
	                if (list[k]['fafang'] == "address") {
	                    listData.push(list[k]);
	                }
	            }
	            totalLogisticsLength = listData.length;
	            var html = template.build(tpl)(listData);
	            if (listData.length >= 0) {
	                if (!$('#' + logisticsId).length) {
	                    $('body').append(html);
	                } else {
	                    $('#' + logisticsId).replaceWith(html).show();
	                }
	                msgbox.show(logisticsId);
	            }
	        } else if (result == -100) {
	            logout();
	            login();
	        } else {
	            msgbox(rs.msg);
	        }
	    }, function() {
	        l_status = false;
	    });
	}
	
	$(document).on("click", "#act_logistics_popbox .turn_nav a", function() {
	    var $this = $(this);
	    if ($this.hasClass('disable')) {
	        return;
	    }
	
	    var $curGoods = $("#act_logistics_popbox").find("div.cur_logistics");
	    var idx = $curGoods.attr('index');
	    idx = idx && Number(idx) || 0;
	
	    if ($this.hasClass('prev')) {
	        idx--;
	        $curGoods.removeClass('cur_logistics').hide().prev().addClass('cur_logistics').show();
	    } else if ($this.hasClass('next')) {
	        idx++;
	        $curGoods.removeClass('cur_logistics').hide().next().addClass('cur_logistics').show();
	    }
	
	    if (idx <= 0) {
	        $this.parent().find("a.prev").addClass('disable');
	    } else {
	        $this.parent().find("a.prev").removeClass('disable');
	    }
	
	    if (idx >= totalLogisticsLength - 1) {
	        $this.parent().find("a.next").addClass('disable');
	    } else {
	        $this.parent().find("a.next").removeClass('disable');
	    }
	});
	
	module.exports = LogisticsList;

/***/ }),
/* 15 */
/***/ (function(module, exports) {

	module.exports = "<div class=\"pop_logistics\" id=\"act_logistics_popbox\"><div class=\"pop_hd\"><p class=\"pop_tit\">我的物流</p><a href=\"javascript:msgExit();\" class=\"pop_close\" title=\"关闭\">X</a></div><div class=\"pop_cont\">{{if $d.length}}{{for $d}}<div class=\"{{$k < 1 ? \'cur_logistics\' : \'\'}}\" index=\"{{$k}}\" style=\"display: {{($k < 1 ? \'\' : \'none\') }};\"><dl><dt>奖品名称：</dt><dd class=\"tc_red\">{{for $v.tname.split(\"+\")}}<span class=\"award_name\">{{$v}}</span>{{/for}}</dd></dl><dl><dt>物流状态：</dt>{{if $v.keycode}}<dd class=\"tc_red\">已发货</dd>{{else}}<dd class=\"tc_red\">待发货</dd>{{/if}}</dl><dl><dt>承运来源：</dt>{{if $v.keycode }}<dd>{{$v.keycode.split(\',\')[0] }}</dd>{{else}}<dd>暂无</dd>{{/if}}</dl><dl><dt>运单编号：</dt>{{if $v.keypwd }}<dd>{{$v.keypwd }}</dd>{{else}}<dd>暂无</dd>{{/if}}</dl><dl><dt>官方电话：</dt>{{if $v.keycode && $v.keycode.split(\',\')[1]}}<dd>{{$v.keycode.split(\',\')[1]}}</dd>{{else}}<dd>暂无</dd>{{/if}}</dl></div>{{/for}}{{else}}<div><dl><dt>奖品名称：</dt><dd class=\"tc_red\"><span class=\"award_name\">暂无</span></dd></dl><dl><dt>物流状态：</dt><dd class=\"tc_red\">暂无</dd></dl><dl><dt>承运来源：</dt><dd>暂无</dd></dl><dl><dt>运单编号：</dt><dd>暂无</dd></dl><dl><dt>官方电话：</dt><dd>暂无</dd></dl></div>{{/if}}<a href=\"http://www.kuaidi100.com/?from=openv\" target=\"_blank\" class=\"link_query\">查看物流进展 &gt;&gt;</a><div class=\"turn_nav\" style=\"display: {{$d.length > 1 ? \'\' : \'none\'}};\"><a href=\"javascript:;\" class=\"prev disable\" title=\"上一页\">上一页</a><a href=\"javascript:;\" class=\"next\" title=\"下一页\">下一页</a></div></div></div>"

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(1);
	var msgbox = __webpack_require__(7);
	var actid = active_cfg.base.actid;
	var msg_cofig = {
	    "address": {
	        opts: {
	            btn_title: "填写资料",
	            btn_href: "javascript:void(0);",
	            btn_target: "0",
	            boxTitle: "恭喜亲中奖啦！",
	            btn_class: "act_address"
	        }
	    },
	    "info": {
	        opts: {
	            btn_title: "我的收货地址",
	            btn_href: "javascript:void(0);",
	            btn_target: "0",
	            boxTitle: "恭喜亲中奖啦！",
	            btn_class: "act_qq_sub"
	        }
	    }
	}
	
	$.fn.lottery = function(_config) {
	    var config = {
	        giftItem: 'li', //单个奖品选择器
	        sort: [0, 1, 2, 7, 3, 6, 5, 4], //排序，默认为顺序
	        targetClass: 'on', //选中时的class，默认on
	        fastSpeed: 80, //快速阶段的速度(定时器时间间隔)，默认80
	        slowSpeed: 444, //慢速阶段的速度(定时器时间间隔)，默认400
	        startStep: 5, //开头的慢速阶段跑几步，默认4
	        endStep: 6, //结束的慢速阶段跑几步，默认4
	        startBtn: '.start_btn',
	        lottery_url: location.protocol + '//dyactive2.vip.xunlei.com/iface/?action=getLottery&actid=', //获取抽奖结果的url
	        ani: true,
	        lotteryAfter: null,
	        gid: ''
	    };
	
	    $.extend(config, _config);
	
	    var islottery;
	    var timeIntervalId; //定时器
	    var curStatus; //0:停止  1:启动截断 2:中间快速阶段  3:中奖减速阶段
	    var giftIndex; //抽中奖品的位置,-1表示还没获得
	    var curIndex; //当前在哪个位置
	    var runCount; //累计总共跑了几个位置
	    var endCallback; //用来注册结束时回调的函数
	    function reset() {
	        curStatus = 0; //0:停止  1:启动截断 2:中间快速阶段  3:中奖减速阶段
	        giftIndex = -1; //抽中奖品的位置,-1表示还没获得
	        curIndex = 0; //当前在哪个位置
	        runCount = 0; //累计总共跑了几个位置
	    }
	    reset();
	
	    var $lotteryBox = this.eq(0);
	    var giftCount = $lotteryBox.find(config.giftItem).length; //奖品总数
	    var idx = 0;
	    if (!config.sort || config.sort.length != giftCount) {
	        $lotteryBox.find(config.giftItem).each(function() {
	            $(this).attr('sort', idx);
	            idx++;
	        });
	    } else {
	        $lotteryBox.find(config.giftItem).each(function() {
	            $(this).attr('sort', config.sort[idx]);
	            idx++;
	        });
	    }
	
	    function run() {
	        reset();
	        focusToNext();
	        curStatus = 1; //开始
	        myInterval(config.slowSpeed);
	    }
	
	    //设置定时器，私有函数
	    function myInterval(speed) {
	        clearInterval(timeIntervalId);
	        timeIntervalId = setInterval(function() {
	            runCount++;
	            curIndex = runCount % giftCount;
	            focusToNext();
	            stepFunction();
	        }, speed);
	    }
	
	    //设置当前dom状态，私有函数
	    function focusToNext() {
	        $lotteryBox.find(config.giftItem).removeClass(config.targetClass);
	        $lotteryBox.find(config.giftItem + '[sort=' + curIndex + ']').eq(0).addClass(config.targetClass);
	    }
	
	    //每跑一步检测当前状态，私有函数
	    function stepFunction() {
	        if (curStatus == 1 && runCount == config.startStep) {
	            curStatus = 2; //加速
	            myInterval(config.fastSpeed);
	        }
	        if (curStatus == 2 && (runCount >= (config.startStep + giftCount * 2))) { //至少要快速跑一圈
	            if (giftIndex != -1) {
	                var needNum = giftCount - config.endStep - (curIndex - giftIndex);
	                if (needNum == 0 || needNum == giftCount) {
	                    curStatus = 3; //中奖减速阶段
	                    myInterval(config.slowSpeed);
	                }
	            }
	        }
	        if (curStatus == 3 && curIndex == giftIndex) {
	            end();
	        }
	    }
	
	    function end() {
	        clearInterval(timeIntervalId);
	        setTimeout(function() {
	            endCallback && endCallback();
	        }, 200);
	    }
	
	    function setGift(_giftIndex, _endCallback) {
	        reset();
	        giftIndex = parseInt(_giftIndex);
	        endCallback = _endCallback;
	        //以下mzk修改
	        //run();
	
	        focusToNext();
	        curStatus = 1; //开始
	        myInterval(config.slowSpeed);
	    }
	
	    function afterLottery(rs) {
	        if (config.after && (config.after(rs) === false)) {
	            return;
	        }
	        if (msg_cofig[rs.data.fafang]) {
	            msgbox.showErrorMsg(rs.msg, msg_cofig[rs.data.fafang]['opts']);
	        } else {
	            msgbox.showErrorMsg(rs.msg);
	        }
	    }
	
	    function start() {
	        if (islottery) return;
	        islottery = true;
	        $.jsonp(config.lottery_url, {
	            actid: actid,
	            gid: config.gid
	        }, function(rs) {
	            if (config.before && (config.before(rs) === false)) {
	                islottery = false;
	                return;
	            }
	            if (rs.result == 0) {
	                if (config.ani) {
	                    setGift(rs.data.frontid, function() {
	                        afterLottery(rs);
	                        islottery = false;
	                    });
	                } else {
	                    afterLottery(rs);
	                    islottery = false;
	                }
	            } else {
	                msgbox.showErrorMsg(rs.msg);
	                islottery = false;
	            }
	        });
	    }
	    $(config.startBtn).off('click').on('click', function() {
	        if (!haslogin()) {
	            login();
	            return false;
	        }
	
	        start();
	    });
	    return {
	        start: start
	    };
	}


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(1);
	var template = __webpack_require__(12);
	$.fn.textSlider = function(set) {
		var config = $.extend({
			direction: 'top',
			speed: 2000,
			wait : 1000,
			child: 'ul',
			line: 1,
			per: 1,
			html: ''
		}, set);
		return this.each(function() {
			$.fn.textSlider.scllor($(this), config);
		});
	};
	$.fn.textSlider.scllor = function($this, config) {
		var wrap = $this.find(config.child).eq(0);
		if(config.html) {
			wrap.html(config.html);
		} else if(config.data) {
			var tpl = $this.find('script').html();
			if(tpl) {
				wrap.html(template.build(tpl)(config.data))
			}
		}
	
		var timer;
		var sub = wrap.children();
		if(sub.length === 0) {
			return;
		}
		var auto = true;
		config.sub = sub.get(0).tagName.toLocaleString();
		var liHight, upHeight, liWigth, leftWidth;
		var ing = false;
		var scrollUp = function() {
			liHight = 0;
			upHeight = 0;
			for (var i = 0; i < config.line; i++) {
				liHight = wrap.children().eq(i * config.per).outerHeight(true);
				upHeight = upHeight - liHight;
			}
			ing = true;
			wrap.animate({
				marginTop: upHeight
			}, config.speed, function() {
				wrap.find(config.sub + ':lt(' + config.per * config.line + ')').appendTo(wrap);
				wrap.css({
					marginTop: 0
				});
				ing = false;
				auto && (timer = setTimeout(scrollUp, config.wait));
			});
		};
	
		var scrollLeft = function() {
			liWigth = 0;
			leftWidth = 0;
			for (var i = 0; i < config.line; i++) {
				liWigth = wrap.children().eq(i * config.per).outerWidth(true);
				leftWidth = leftWidth - liWigth;
			}
			ing = true;
			wrap.animate({
				marginLeft: leftWidth
			}, config.speed, function() {
				wrap.find(config.sub + ':lt(' + config.per * config.line + ')').appendTo(wrap);
				wrap.css({
					marginLeft: 0
				});
				ing = false;
				auto && (timer = setTimeout(scrollLeft, config.wait));
			});
		};
	
		var bottom = function() {
			liWigth = 0;
			leftWidth = 0;
			var all = wrap.children().length;
			var _top = 0;
			$.each(wrap.children(), function() {
	
			})
			for (var i = 0; i < config.line; i++) {
				liWigth = wrap.children().eq(i * config.per).outerWidth(true);
				leftWidth = leftWidth - liWigth;
			}
			ing = true;
			wrap.animate({
				marginLeft: leftWidth
			}, config.speed, function() {
				wrap.find(config.sub + ':lt(' + config.per * config.line + ')').appendTo(wrap);
				wrap.css({
					marginLeft: 0
				});
				ing = false;
				auto && (timer = setTimeout(scrollLeft, config.wait));
			});
		};
		var fn;
		switch(config.direction) {
			case 'left':
				fn = scrollLeft;
				break;
			case 'bottom':
				fn = bottom;
				break;
			default:
				fn = scrollUp;
		}
		var autoPlay = function() {
			auto = true;
			if(!ing) {
				timer = setTimeout(fn, config.wait);
			}
		};
		var autoStop = function() {
			auto = false;
			clearTimeout(timer);
		};
		if(!('ontouchstart' in window)) {
			$this.hover(autoStop, autoPlay);
		}
		fn();
	};


/***/ })
/******/ ]);


// WEBPACK FOOTER //
// thunder.min.js